import { FetchResult, gql } from '@apollo/client';
import { inject, injectable } from 'tsyringe';
import { AmGraphQlClient } from 'app/cross-cutting-concerns/communication/clients/AmGraphQlClient';
import {
  MutationAcceptTermsAndConditionArgs,
  ResponseAcceptTermsAndCondition,
} from 'app/cross-cutting-concerns/communication/interfaces/am-api-graphql';

export interface TermsConditionsAcceptResponse {
  acceptTermsAndCondition: ResponseAcceptTermsAndCondition;
}
export type TermsConditionsClientAcceptOptions = MutationAcceptTermsAndConditionArgs;

@injectable()
export class TermsConditionsClient {
  constructor(@inject('AmGraphQlClient') private client: AmGraphQlClient) {}

  public acceptTermsAndCondition = async ({
    input,
  }: TermsConditionsClientAcceptOptions): Promise<FetchResult<TermsConditionsAcceptResponse>> =>
    this.client.mutate({
      mutation: gql`
        mutation TermsAndConditionAccept($input: InputAcceptTermsAndCondition!) {
          acceptTermsAndCondition(input: $input) {
            data {
              acceptedAt
              customerId
              version
            }
          }
        }
      `,
      variables: {
        input,
      },
    });
}
